<ng-container *ngIf="tipoError">
  <ion-list mode="ios" lines="node" class="list-content">
    <ion-item mode="md" color="transparent" lines="none">
      <ion-img [src]="tipoError.image" class="image-empty"></ion-img>
    </ion-item>

    <ion-item
      mode="md"
      color="transparent"
      lines="none"
      class="ion-text-center"
    >
      <ion-label mode="md" class="sin-datos">
        {{ tipoError.title }}

        <p class="no-hemos-encontrado">
          {{ tipoError.description }}
        </p>
      </ion-label>
    </ion-item>
  </ion-list>
</ng-container>
